import { ChevronLeftSystemIcon, ChevronRightSystemIcon } from "@nib/icons";
import { Inline, Stack } from "@nib/layout";
import Link from "@nib-components/link";
import GatsbyLink, { navigate } from "gatsby-link";
import React from "react";
import PropTypes from "prop-types";
import useWindowDimensions from "../../utils/breakpoints";
import Copy from "@nib-components/copy";
import { PrimaryButton } from "@nib-components/button";
import SocialShare from "../SocialShare";

import withQueryParams from "../../utils/withQueryParams";

const MobileBreadCrumb = () => {
  return (
    <Inline space={2} verticalAlign="center">
      <ChevronLeftSystemIcon size="xs" />
      {/* TODO: this was throwing an error in primarybutton package */}
      {/* <Link onClick={() => navigate(-1)} as={PrimaryButton}>
        Back
      </Link> */}
      <Link onClick={() => navigate(-1)}>Back</Link>
    </Inline>
  );
};

const DesktopBreadCrumb = ({ currentPageName }) => {
  return (
    <Inline space={4} verticalAlign="center">
      <Link as={GatsbyLink} to={withQueryParams("/")}>
        Home
      </Link>
      <ChevronRightSystemIcon size="xs" />
      <Copy>{currentPageName}</Copy>
    </Inline>
  );
};
export const BreadCrumb = ({ currentPageName, socialShare }) => {
  const { isMobile } = useWindowDimensions();
  return (
    <Stack space={4}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {isMobile ? <MobileBreadCrumb /> : <DesktopBreadCrumb currentPageName={currentPageName} />}
        {socialShare ? <SocialShare title={currentPageName} /> : <></>}
      </div>
    </Stack>
  );
};

BreadCrumb.propTypes = {
  currentPageName: PropTypes.string,
  socialShare: PropTypes.bool,
};

DesktopBreadCrumb.propTypes = {
  currentPageName: PropTypes.string,
};
